<template>
    <div>
        <v-banner
            v-if="user.hasRoles.includes('Archived Teacher')"
            color="soli-status-red"
            class="mb-1"
            ><div class="white--text flex justify-center">
                This teacher has been archived
            </div></v-banner
        >
        <v-row
            dense
            class="pb-3 px-1 animate__animated animate__fadeIn"
            :class="{ 'mt-1': $vuetify.breakpoint.xs }"
        >
            <SoliStats
                v-if="can('View statistical reports')"
                :key="dateRange[0] + dateRange[1]"
                :activeMemberships="
                    studentHistory?.filter((e) => e.activeMemberships).length ??
                    null
                "
                :firstVisits="
                    studentHistory?.filter((e) => e.assessments).length ?? null
                "
                :enrollments="
                    studentHistory?.filter((e) => e.enrollments).length ?? null
                "
                :withdrawals="
                    studentHistory?.filter((e) => e.withdrawals).length ?? null
                "
                :links="false"
                @click="filterStudents($event.filter)"
                :selected="statSelection"
            >
            </SoliStats>
        </v-row>
        <v-card class="soli-round my-3">
            <v-container class="px-3" fluid>
                <ReportHeader
                    filter
                    subtitle="Current status of all students in this period"
                    :dateRange="dateRange"
                    :reportUrl="`/profile/${user.id}/student-history`"
                    @search="search = $event"
                    dateOptions="all, month, year"
                    monthSelector
                />
                <v-data-table
                    :headers="headers"
                    :items="studentHistory || []"
                    disable-pagination
                    hide-default-footer
                    show-select
                    mobile-breakpoint="0"
                    :loading="!studentHistory"
                    :search="search"
                    item-key="option_id"
                    v-model="selectedPeople"
                    @click:row="$log($event.id)"
                >
                    <template v-slot:top>
                        <div class="font-semibold soli-grey text-lg py-2 px-4">
                            {{
                                `${
                                    selectedPeople.length
                                        ? `Selected: ${selectedPeople.length} `
                                        : `Total: ${
                                              studentHistory?.length ?? ""
                                          }`
                                }`
                            }}
                        </div>
                    </template>

                    <template v-slot:[`item.name`]="{ item }">
                        <div class="d-flex align-center py-2">
                            <v-list-item-avatar
                                style="float: left"
                                class="my-0"
                            >
                                <v-img :src="item.profile_photo_url"></v-img>
                            </v-list-item-avatar>
                            <div>
                                <v-list-item-title>
                                    <Link :href="`/profile/${item.id}/account`">
                                        {{ item.name }}
                                    </Link>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ item.email }}
                                </v-list-item-subtitle>
                            </div>
                        </div>
                    </template>
                    <template v-slot:[`item.lesson`]="{ item }">
                        <div class="d-flex align-center py-2">
                            <div>
                                <v-list-item-title>
                                    <small>
                                        {{
                                            item.lesson.group_event?.title ??
                                            item.lesson.instrument.name
                                        }}
                                    </small>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ item.lesson.type }}
                                </v-list-item-subtitle>
                            </div>
                        </div>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <div>{{ item.status }}</div>
                    </template>
                    <template v-slot:[`item.start_date`]="{ item }">
                        <div>
                            {{
                                item.start_date
                                    ? globalMomentDateDots(item.start_date)
                                    : null
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.end_date`]="{ item }">
                        <div>
                            {{
                                item.end_date
                                    ? globalMomentDateDots(item.end_date)
                                    : null
                            }}
                        </div>
                    </template>
                    <template v-slot:[`item.withdraw_date`]="{ item }">
                        <div>
                            {{
                                item.withdraw_date
                                    ? globalMomentDateDots(item.withdraw_date)
                                    : null
                            }}
                        </div>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </div>
</template>

<script>
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment.js";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";

export default {
    name: "TeacherStudents",
    props: {
        user: {
            type: Object,
            default: () => {},
        },
        studentHistory: {
            type: Array,
            default: null,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
        trends: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        Link,
        ReportHeader,
    },
    mixins: [globalMoment],
    data() {
        return {
            headers: [
                {
                    text: "User Info",
                    value: "name",
                },
                {
                    text: "Recent Lesson",
                    value: "lesson",
                },
                {
                    text: "Status",
                    value: "status",
                },
                {
                    text: "Start Date",
                    value: "start_date",
                },
                {
                    text: "End Date",
                    value: "end_date",
                },
                {
                    text: "activeMemberships",
                    align: " d-none",
                    sortable: false,
                    value: "activeMemberships",
                    filter: (value) => {
                        if (this.statSelection !== "activeMemberships")
                            return true;
                        return value;
                    },
                },
                {
                    text: "firstVisits",
                    align: "start",
                    sortable: false,
                    align: " d-none",
                    value: "assessments",
                    filter: (value) => {
                        if (this.statSelection !== "firstVisits") return true;
                        return value;
                    },
                },
                {
                    text: "enrollments",
                    align: "start",
                    sortable: false,
                    align: " d-none",
                    value: "enrollments",
                    filter: (value) => {
                        if (this.statSelection !== "enrollments") return true;
                        return value;
                    },
                },
                {
                    text: "withdrawals",
                    align: "start",
                    sortable: false,
                    align: " d-none",
                    value: "withdrawals",
                    filter: (value) => {
                        if (this.statSelection !== "withdrawals") return true;
                        return value;
                    },
                },
            ],
            search: null,
            selectedPeople: [],
            statSelection: null,
        };
    },
    methods: {
        filterStudents(event) {
            if (event == this.statSelection) {
                this.statSelection = null;
            } else {
                this.statSelection = event;
            }
        },
    },
    watch: {
        selectedPeople(val) {
            this.$emit("selectedPeople", val);
        },
        /*dateRange() {
            this.statSelection = null;
        },*/
    },
};
</script>
